import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SharedService } from '../../services/shared.service';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-cookie-dialog',
  templateUrl: './cookie-dialog.component.html',
  styleUrls: ['./cookie-dialog.component.scss'],
  providers: []
})
export class CookieDialogComponent implements OnInit {

  constructor(private router: Router, public sharedService: SharedService, private titleService:Title) { }
  public closePopup = false;

  ngOnInit() {
    if (this.getConsent()) {
      this.accept();
    }
    else if(this.hasAnswered()) {
      this.deny();
      this.closePopup = true;
    }
    else {
      this.sharedService.acceptedConsent = false;
      this.closePopup = false;
    }
  }

  public showCookieDialog() {
    this.closePopup = false;
  }

  public loadScript() {
    let body = <HTMLDivElement>document.body;
    let script = document.createElement('script');
    script.innerHTML = '';
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-XXXXXXXX';
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  }

  public deny(): void {
    this.sharedService.acceptedConsent = false;
    //this.deleteCookie("_ga");
    //this.deleteCookie("_ga_ZZ7HCE7DX4");
    this.setConsent(false);
    this.closePopup = true;
  }

  public accept(): void {
    //this.loadScript();
    this.sharedService.acceptedConsent = true;
    this.setConsent(true);
    this.closePopup = true;
  }

  public hasAnswered(): boolean {
    return localStorage.getItem('cookies_consented') !== null;
  }

  public getConsent(): boolean {
    return localStorage.getItem('cookies_consented') === 'true';
  }

  public setConsent(value: boolean): void {
    localStorage.setItem('cookies_consented', value ? 'true' : 'false');
  }

  private deleteCookie(name: string) {
    this.setCookie(name, '', -1);
  }

  private setCookie(name: string, value: string, expireDays: number, path: string = 'path=/;') {
    let d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    let domain : string = "localhost";
    if(window.location.hostname != "localhost")
        {
          domain = ".frankford-it.at";
        }

    let cpath: string = path ? `; path=${path}; domain=${domain}` : '';
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }

}